import React from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";

const days = (d) => `${Math.round(d)}d`;

const Product = ({ product_name, sku_code, brand }) => (
  <Box>
    <Typography fontSize={13} fontWeight={500}>{product_name}</Typography>
    <Typography fontSize={11} color="text.secondary">
      {sku_code} · {brand}
    </Typography>
  </Box>
);

export default function SlowMovers({ data = [] }) {
  if (!data.length) {
    return (
      <Box mb={3}>
        <Typography fontSize={13.5} fontWeight={500} mb={1}>
          Slow movers
        </Typography>
        <Paper sx={{ p: 4, textAlign: "center" }}>
          <Typography>No slow movers</Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box mb={3}>
      <Box display="flex" gap={1} alignItems="center" mb={1.5}>
        <Box width={3} height={16} bgcolor="#BA7517" borderRadius={1} />
        <Typography fontSize={13.5} fontWeight={500}>
          Slow movers
        </Typography>
      </Box>

      <Paper variant="outlined">
        <Table size="small">
          <TableHead sx={{ background: "var(--color-background-secondary)" }}>
            <TableRow>
              <TableCell>Product</TableCell>
              <TableCell>Stock</TableCell>
              <TableCell>Sales</TableCell>
              <TableCell>Days cover</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((r) => (
              <TableRow key={r.sku_code} hover>
                <TableCell><Product {...r} /></TableCell>
                <TableCell>{r.inventory_units}</TableCell>
                <TableCell>{r.units_sold_30d}</TableCell>
                <TableCell sx={{ color: "warning.main", fontWeight: 500 }}>
                  {days(r.stock_cover_days_30d)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}